import { Box, Typography } from "@mui/material"
import { type CSSProperties, type ReactNode, isValidElement } from "react"
import { SearchNoResultIcon } from "../../icons"

export interface EmptySectionProps {
  size?: number | string
  color?: CSSProperties["color"]
  msg?: ReactNode
}

export const EmptySection = ({ msg, ...iconProps }: EmptySectionProps) => {
  return (
    <Box display={"grid"} sx={{ placeContent: "center" }} gap={1}>
      <Box mx={"auto"}>
        <SearchNoResultIcon {...iconProps} />
      </Box>
      {isValidElement(msg) ? (
        msg
      ) : (
        <Typography
          fontWeight={500}
          sx={{ color: ({ palette }) => palette.primary.light2 }}
          textAlign={"center"}
        >
          {msg ?? "Pas de données disponibles pour cette section"}
        </Typography>
      )}
    </Box>
  )
}
